import { createSlice } from "@reduxjs/toolkit";

const readCollapsed = () => {
  try {
    return localStorage.getItem("adminSidebarCollapsed") === "1";
  } catch {
    return false;
  }
};

const adminSidebarSlice = createSlice({
  name: "adminSidebar",
  initialState: {
    isOpen: false, // mobile drawer
    collapsed: readCollapsed(), // desktop rail
  },
  reducers: {
    toggleAdminSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    closeAdminSidebar: (state) => {
      state.isOpen = false;
    },
    toggleAdminSidebarCollapsed: (state) => {
      state.collapsed = !state.collapsed;
      try {
        localStorage.setItem(
          "adminSidebarCollapsed",
          state.collapsed ? "1" : "0"
        );
      } catch {
        /* ignore */
      }
    },
    setAdminSidebarCollapsed: (state, action) => {
      state.collapsed = Boolean(action.payload);
      try {
        localStorage.setItem(
          "adminSidebarCollapsed",
          state.collapsed ? "1" : "0"
        );
      } catch {
        /* ignore */
      }
    },
  },
});

export const {
  toggleAdminSidebar,
  closeAdminSidebar,
  toggleAdminSidebarCollapsed,
  setAdminSidebarCollapsed,
} = adminSidebarSlice.actions;
export default adminSidebarSlice.reducer;
